import {useQuery} from '@tanstack/react-query';
import {apiClient} from '@common/http/query-client';
import {BackendResponse} from '@common/http/backend-response/backend-response';
import {ResolvedCustomAuthPage} from '@app/custom-auth-pages/custom-auth-page';

interface Response extends BackendResponse {
  page: ResolvedCustomAuthPage;
}

export function useResolvedCustomAuthPage(path: string, enabled = true) {
  return useQuery({
    queryKey: ['custom-auth-page', path],
    queryFn: () => fetchResolvedCustomAuthPage(path),
    enabled,
    retry: false,
  });
}

function fetchResolvedCustomAuthPage(path: string): Promise<Response> {
  return apiClient
    .get<Response>('custom-auth-pages/resolve', {params: {path}})
    .then(response => response.data);
}
